import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {WidgetBoxComponent} from "./widget-box.component";



@NgModule({
  declarations: [WidgetBoxComponent],
  exports: [WidgetBoxComponent],
  imports: [
    CommonModule
  ]
})
export class WidgetBoxModule { }
